import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { TAXONOMY_CLIENT } from "../../../../utils/consts";
import { PRODUCT_COUNT_QUERY } from "../queries/productCountQuery";

function useProductCountQuery(vendorId: number) {
  const { data, loading } = useQuery(PRODUCT_COUNT_QUERY, {
    variables: { vendorId },
    skip: vendorId === 0,
    context: { clientName: TAXONOMY_CLIENT },
  });

  const count = useMemo(() => data?.product.count || 0, [data]);

  return { count, loading };
}

export default useProductCountQuery;
